export default "__VITE_ASSET__A6IsLQgH__"